import { Component, inject } from "@angular/core";
import { LgTranslateService, LG_LOCALIZATION_SETTINGS } from "@logex/framework/lg-localization";
import { IQuickSettingsMenuChoice, QuickSettingsMenuType } from "@logex/framework/ui-core";
import { SharedLocalizationSettingsService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";

@Component({
    selector: "mrdm-self-service-frontend-language-switch",
    templateUrl: "./language-switch.component.html",
    styleUrls: ["./language-switch.component.scss"],
    standalone: false
})
export class LanguageSwitchComponent {
    private _localizationSettings = inject<SharedLocalizationSettingsService>(LG_LOCALIZATION_SETTINGS);
    private _translate = inject(LgTranslateService);

    public _options: IQuickSettingsMenuChoice[] = [];
    public _currentLanguage: string;

    constructor() {
        this._initOptions();
        this._currentLanguage = this._localizationSettings.locale;
    }

    private _initOptions(): void {
        this._options = this._localizationSettings.availableLanguages.map(language => ({
            id: language,
            nameLC: this._translate.translate("FW._Language_switch." + language),
            type: QuickSettingsMenuType.Choice,
            onClick: () => this._localizationSettings.switchCurrentLanguage(language)
        }));
    }
}
